import * as dayjs from "dayjs";

export interface ICadastroCartao {
  cartao?: string | null;
  vencimento?: string | null;
  ccv?: number | null;
  nomecartao?: string | null;
  cpf?: string | null;
  tipo?: string | null;
  cnpj?: string | null;
  documento?: string | null;
}

export class CadastroCartao implements ICadastroCartao {
  constructor(
    public cartao?: string | null,
    public vencimento?: string | null,
    public ccv?: number | null,
    public nomecartao?: string | null,
    public cpf?: string | null,
    public tipo?: string | null,
    public cnpj?: string | null,
    public documento?: string | null,
  ) { }
}

